<ng-container *ngIf="!loading">
  <ng-container *ngIf="isPortalPublic; else publicDisabledPortal">
    <ng-container *ngIf="!showRouteRestrictedNotFound; else certificationDisabledPortal">
      <app-error-banner></app-error-banner>
      <app-header
        [logoUrl]="logoUrl"
        [logoWidth]="logoWidth"
        [logoHeight]="logoHeight"
        [nameBranch]="nameBranch"
        [headerLogoUrl]="headerLogoUrl"
        [headerLogoWidth]="headerLogoWidth"
        [headerLogoHeight]="headerLogoHeight"
        [isAdmin]="isAdmin">
      </app-header>
      <router-outlet></router-outlet>
      <app-footer
        [logoUrl]="footerLogoUrl"
        [logoWidth]="footerLogoWidth"
        [logoHeight]="footerLogoHeight">
      </app-footer>
      <app-toast></app-toast>
      <app-system-toast></app-system-toast>
    </ng-container>
  </ng-container>
  <ng-template #certificationDisabledPortal>
    <app-header
      [logoUrl]="logoUrl"
      [logoWidth]="logoWidth"
      [logoHeight]="logoHeight"
      [nameBranch]="nameBranch"
      [headerLogoUrl]="headerLogoUrl"
      [headerLogoWidth]="headerLogoWidth"
      [headerLogoHeight]="headerLogoHeight"
      [isAdmin]="isAdmin">
    </app-header>
    <app-page-not-found></app-page-not-found>
    <app-footer
      [logoUrl]="footerLogoUrl"
      [logoWidth]="footerLogoWidth"
      [logoHeight]="footerLogoHeight">
    </app-footer>
  </ng-template>
  <ng-template #publicDisabledPortal>
    <app-header
      [logoUrl]="logoUrl"
      [logoWidth]="logoWidth"
      [logoHeight]="logoHeight"
      [nameBranch]="nameBranch"
      [headerLogoUrl]="headerLogoUrl"
      [headerLogoWidth]="headerLogoWidth"
      [headerLogoHeight]="headerLogoHeight"
      [isAdmin]="isAdmin">
    </app-header>
    <app-page-not-found></app-page-not-found>
    <app-footer
      [logoUrl]="footerLogoUrl"
      [logoWidth]="footerLogoWidth"
      [logoHeight]="footerLogoHeight">
    </app-footer>
  </ng-template>
</ng-container>
